import React from "react";

const Header = ({handleDarkMode})=>{

    return (
    <div className="header">
    
    <h1>Notes</h1>
    <button onClick={()=> handleDarkMode((preDarkMode)=> !preDarkMode)} className="save">Dark Side</button>
    </div>
    )
}

export default Header;